import { reactive, set } from 'vue-demi';
import { INCREASE_TYPE } from '../common/enum';
const { useCommonApi } = require('@fegobull/webapi').use;
const request = useCommonApi('etf-rank');

export default (stockList, increaseType) => {
    const chartDataMap = reactive({});
    /* 股票图表数据 */
    const getChartData = async (stock) => {
        const params = {
            symbol: stock.symbol,
            stock_id: stock.stockId,
            market_code: stock.marketCode,
            increase_type: increaseType,
            // 0代表 盘中数据
            req_section: 0
        };
        const r = await request.get(increaseType !== INCREASE_TYPE.CLOSE ? 'quote-kline' : 'quote-minute', params);
        r.price_direct = stock.priceDirect;
        return r;
    };

    const initChartData = () => {
        if (!stockList.value || !stockList.value.length) {
            return;
        }
        stockList.value.map(async (stock) => {
            const chartData = (await getChartData(stock)) || [];
            set(chartDataMap, stock.stockId, chartData);
        });
    };

    return {
        chartDataMap,
        initChartData
    };
};
